module.exports = __webpack_public_path__ + "img/distance-info-2-m.b81af700.png";